import React, { useEffect, useRef, useState } from "react";
import ModalContainer from "../../common/ModalContainer";
import { enqueueSnackbar } from "notistack";
import CommonFreeTextInput from "../../common/inputs/CommonFreeTextInput";
import CommonPhoneNumberInput from "../../common/CommonPhoneNumberInput";
import updateUsersProfile from "../../../controllers/user/updateUsersProfile";

export const CustomerDetailEditModal = ({ setOpen, open, data, callback }) => {
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState({
    companyName: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
  });

  useEffect(() => {
    const sanitizePhone = (phone) => {
      if (!phone) return "";
      return phone.replace(/[^0-9-]/g, "");
    };

    setContent({
      companyName: data?.detail?.agencyName,
      address: data?.detail?.address?.businessLocation,
      firstName: data?.firstName,
      lastName: data?.lastName,
      email: data?.email,
      phone: sanitizePhone(data?.phone),
    });
  }, [open]);

  const handleConfirm = async () => {
    const payload = {
      businessEmail: content?.email,

      businessPhone: content?.phone,
      phone: content?.phone,
      address: {
        ...(data?.detail?.address?.location?.length
          ? data?.detail?.address
          : {}),
        businessLocation: content?.address,
      },
      tradingName: content?.companyName,
      firstName: content.firstName,
      lastName: content.lastName,
      fullName: [content.firstName, content.lastName].join(" "),
    };
    setLoading(true);
    const res = await updateUsersProfile(data?._id, payload).finally(() =>
      setLoading(false),
    );
    if (res.return) {
      callback?.(res?.data);
      enqueueSnackbar("Profile Updated.", { variant: "success" });
      setOpen?.(false);
    } else enqueueSnackbar(res.msg, { variant: "error" });
  };

  return (
    <>
      <ModalContainer
        open={open}
        setOpen={setOpen}
        padding="px-4 py-6"
        title="Edit agent details"
        childClassname="max-w-[600px]"
      >
        <div className="w-full flex flex-col lg:px-4 gap-1">
          <div className="flex flex-col w-full">
            <span className={`block text-sm mb-1 text-gray-600`}>
              Phone number
            </span>
            <CommonPhoneNumberInput
              label={"Phone number"}
              countryCode={
                content?.phone?.split("-")?.length > 0
                  ? content?.phone?.split("-")?.[0]
                  : "234"
              }
              phoneNumber={content?.phone?.split("-")[1]}
              onChange={({ countryCode, phoneNumber }) => {
                setContent({
                  ...content,
                  phone: `${countryCode}-${phoneNumber}`,
                });
              }}
            />
          </div>
          <CommonFreeTextInput
            label={"Email"}
            value={content?.email}
            onChange={(val) => setContent({ ...content, email: val })}
          />
          <CommonFreeTextInput
            label={"Company Name"}
            value={content?.companyName}
            onChange={(val) => setContent({ ...content, companyName: val })}
          />
          <div className="w-full gap-2 items-center flex">
            <CommonFreeTextInput
              label={"First Name"}
              value={content?.firstName}
              onChange={(val) => setContent({ ...content, firstName: val })}
            />
            <CommonFreeTextInput
              label={"Last Name"}
              value={content?.lastName}
              onChange={(val) => setContent({ ...content, lastName: val })}
            />
          </div>
          <CommonFreeTextInput
            label={"Address"}
            value={content?.address}
            onChange={(val) => setContent({ ...content, address: val })}
          />

          <hr className="w-full my-4 border border-gray-300" />
          <div className="flex items-center gap-2">
            <button className="w-32 lg:w-44 rounded-md h-12 bg-white flex items-center justify-center font-bold text-sm">
              Close
            </button>
            <button
              className="flex-1 rounded-md h-12 bg-primary1 text-white flex items-center justify-center font-bold text-sm"
              onClick={() => handleConfirm()}
            >
              {loading ? <div className="buttonLoader"></div> : <>Confirm</>}
            </button>
          </div>
        </div>
      </ModalContainer>
    </>
  );
};
